/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monthlytask_ClaimedInputs */

const en_monthlytask_claimed = /** @type {(inputs: Monthlytask_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

const ar_monthlytask_claimed = /** @type {(inputs: Monthlytask_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اكتمال`)
};

const de_monthlytask_claimed = /** @type {(inputs: Monthlytask_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgeschlossen`)
};

const es_monthlytask_claimed = /** @type {(inputs: Monthlytask_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completado`)
};

const fr_monthlytask_claimed = /** @type {(inputs: Monthlytask_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminé`)
};

const it_monthlytask_claimed = /** @type {(inputs: Monthlytask_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completato`)
};

const ja_monthlytask_claimed = /** @type {(inputs: Monthlytask_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了`)
};

const ko_monthlytask_claimed = /** @type {(inputs: Monthlytask_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`완료`)
};

const pt_br_monthlytask_claimed = /** @type {(inputs: Monthlytask_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluído`)
};

const ru_monthlytask_claimed = /** @type {(inputs: Monthlytask_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выполнено`)
};

const th_monthlytask_claimed = /** @type {(inputs: Monthlytask_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สำเร็จแล้ว`)
};

const tr_monthlytask_claimed = /** @type {(inputs: Monthlytask_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamamlandı`)
};

const zh_cn_monthlytask_claimed = /** @type {(inputs: Monthlytask_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已完成`)
};

const zh_tw_monthlytask_claimed = /** @type {(inputs: Monthlytask_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已完成`)
};

/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Monthlytask_ClaimedInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const monthlytask_claimed = /** @type {((inputs?: Monthlytask_ClaimedInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monthlytask_ClaimedInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_monthlytask_claimed(inputs)
	if (locale === "ar") return ar_monthlytask_claimed(inputs)
	if (locale === "de") return de_monthlytask_claimed(inputs)
	if (locale === "es") return es_monthlytask_claimed(inputs)
	if (locale === "fr") return fr_monthlytask_claimed(inputs)
	if (locale === "it") return it_monthlytask_claimed(inputs)
	if (locale === "ja") return ja_monthlytask_claimed(inputs)
	if (locale === "ko") return ko_monthlytask_claimed(inputs)
	if (locale === "pt_br") return pt_br_monthlytask_claimed(inputs)
	if (locale === "ru") return ru_monthlytask_claimed(inputs)
	if (locale === "th") return th_monthlytask_claimed(inputs)
	if (locale === "tr") return tr_monthlytask_claimed(inputs)
	if (locale === "zh_cn") return zh_cn_monthlytask_claimed(inputs)
	return zh_tw_monthlytask_claimed(inputs)
});